export const getAttentionData = (state, market, ticker) => {
  const normalizedMarket = market.toLowerCase();
  const normalizedTicker = ticker.toLowerCase();

  return state.tickerAttention?.[normalizedMarket]?.[normalizedTicker] || {};
};
